import { BarChart3 } from 'lucide-react'
import { ReportPageLayout, type ReportColumn, type SummaryStat } from './ReportPageLayout'
import { generateMonthlyRevenueReport } from '@/src/lib/api/admin-reports'
import type { MonthlyRevenueReportData } from '@/src/types/admin/reports'

const fmt2 = (v: unknown) =>
  Number(v ?? 0).toLocaleString('th-TH', { minimumFractionDigits: 2 })
const fmtN = (v: unknown) => Number(v ?? 0).toLocaleString('th-TH')

const columns: ReportColumn[] = [
  { key: 'month', label: 'เดือน' },
  { key: 'package_revenue', label: 'รายได้แพ็กเกจ (฿)', format: fmt2 },
  { key: 'topup_revenue', label: 'รายได้เติมเครดิต (฿)', format: fmt2 },
  { key: 'total_revenue', label: 'รายได้รวม (฿)', format: fmt2 },
  { key: 'transaction_count', label: 'จำนวน Tx', format: fmtN },
  { key: 'successful_count', label: 'สำเร็จ', format: fmtN },
  { key: 'rejected_count', label: 'ปฏิเสธ', format: fmtN },
]

function extractRows(data: unknown) {
  const d = data as MonthlyRevenueReportData
  return (d?.monthly_summary ?? []) as unknown as Record<string, unknown>[]
}

function extractSummary(data: unknown): SummaryStat[] {
  const d = data as MonthlyRevenueReportData
  const total = d?.monthly_summary?.reduce((s, r) => s + Number(r.total_revenue ?? 0), 0) ?? 0
  const pkgCount = d?.package_breakdown?.length ?? 0
  return [
    { label: 'รายได้รวมในช่วง', value: `฿${fmt2(total)}` },
    { label: 'จำนวนแพ็กเกจที่มีรายได้', value: `${pkgCount} แพ็กเกจ` },
  ]
}

export default function AdminReportRevenue() {
  return (
    <ReportPageLayout
      title="รายงานรายได้รายเดือน"
      description="MRR, breakdown ตามแพ็กเกจ และ growth rate"
      audience="ผู้บริหาร"
      icon={BarChart3}
      columns={columns}
      fetchFn={generateMonthlyRevenueReport}
      extractRows={extractRows}
      extractSummary={extractSummary}
      filenamePrefix="monthly_revenue"
    />
  )
}
